import React from "react"
import { tv } from "tailwind-variants"

const controlButtonVariants = tv({
  base: "w-12 h-12 flex items-center justify-center transition-colors duration-300 group",
  variants: {
    type: {
      default:
        "text-ro-gray-50 bg-ro-gray-900 border border-ro-gray-900 hover:bg-ro-gray-850 hover:border-ro-gray-850 focus-visible:outline focus-visible:outline-ro-white focus-visible:outline-2 focus-visible:-outline-offset-2",
    },

    state: {
      default: "",
      disabled: "pointer-events-none",
    },
  },
  compoundVariants: [
    {
      type: "default",
      state: "disabled",
      class: "border-ro-gray-100 bg-ro-gray-100 text-ro-gray-300",
    },
  ],
  defaultVariants: { type: "default", state: "default" },
})

const ControlButton = ({
  children,
  className,
  btnType = "default",
  btnState = "default",
  link,
  target,
  ...props
}) => {
  let btnDisabledState = btnState === "disabled" ? { disabled: true } : {}

  return (
    <button
      className={controlButtonVariants({
        type: btnType,
        state: btnState,
        className: className,
      })}
      {...btnDisabledState}
      {...props}
    >
      {children}
    </button>
  )
}

export default ControlButton
